<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.fiNqName" style="width: 140px;" size="small" placeholder="请输入内勤专用"
                        clearable></el-input>
                    <el-input v-model="formDatas.fiNqManage" style="width: 140px;" size="small" placeholder="请输入项目经理"
                        clearable></el-input>
                    <el-input v-model="formDatas.fiNqProjectType" style="width: 140px;" size="small"
                        placeholder="请输入项目分类" clearable></el-input>
                    <el-input v-model="formDatas.fiNqCourseSign" style="width: 140px;" size="small"
                        placeholder="请输入课程标记" clearable></el-input>
                    <el-date-picker v-model="formDatas.fiNqDateStartStrStart" type="date" value-format="yyyy-MM-dd"
                        placeholder="选择上课开始日期" style="width: 160px" size="small" clearable @change="partserch">
                    </el-date-picker>
                    <span style="margin: 0 10px">-</span>
                    <el-date-picker v-model="formDatas.fiNqDateStartStrEnd" type="date" value-format="yyyy-MM-dd"
                        placeholder="选择上课结束日期" style="width: 160px" size="small" clearable @change="partserch">
                    </el-date-picker>
                    <!-- <el-select v-model="formDatas.fiFilesStatus" size="small" clearable placeholder="请选择是否有大文件"
                        style="width: 130px" @change="partserch">
                        <el-option label="否" :value="1" key="1"></el-option>
                        <el-option label="是" :value="2" key="2"></el-option>
                    </el-select>
                    <el-select v-model="formDatas.fiFilesStatusDing" size="small" clearable placeholder="请选择上传钉盘状态"
                        style="width: 130px" @change="partserch">
                        <el-option label="未上传" :value="1" key="1"></el-option>
                        <el-option label="已上传" :value="2" key="2"></el-option>
                    </el-select> -->
                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <!-- <el-button type="warning" size="small" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption" row-key-field-name="fiId"
                        :cellSelectionOption="cellSelectionOption" style="width: 100%" :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>

            <!-- 详情 -->
            <el-dialog title="详情" :visible.sync="IsDetail" width="70%" top="8vh">


                <div style="max-height: 500px; overflow-y: scroll">
                    <el-descriptions :column="3" border :labelStyle="{
                        color: '#409EFF',
                        textAlign: 'center',
                        width: '14%',
                        fontSize: '12px'
                    }" :contentStyle="{ textAlign: 'center', width: '18%', fontSize: '12px' }">
                        <el-descriptions-item label="项目课程标记">{{ DetailArr.fiNqCourseSign }}</el-descriptions-item>
                        <el-descriptions-item :span="2" label="项目分类">{{ DetailArr.fiNqProjectType }}</el-descriptions-item>
                        <el-descriptions-item :span="3" label="内勤专用">{{ DetailArr.fiNqName }}</el-descriptions-item>
                    </el-descriptions>
                    <p style="margin: 10px;">行程详情:</p>
                    <!-- <el-row style="margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                        <el-button type="warning" size="small" style="margin-right: 10px;"
                            @click="DownDd(DetailArr)">下载文件到钉盘</el-button>
                    </el-row> -->
                    <el-table :data="DetailArr.fxxkItineraryDingtalkItemList" border highlight-current-row :header-cell-style="{
                        textAlign: 'center',
                        background: 'rgba(0,170,255,0.5)',
                        color: 'black',
                        border: 'none'
                    }" style="width: 100%;margin:12px 0 0 0;">
                        <el-table-column label="项目经理" align="center" prop="fidiUser">
                        </el-table-column>
                        <el-table-column label="年月" align="center" prop="fidiDateMonth">
                        </el-table-column>
                        <el-table-column label="日期" align="center" prop="fidiDateDay">
                        </el-table-column>
                    </el-table>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>

import { getFxxkItineraryDingtalkList, addAjPurchasePublicItem, updateAjPurchasePublicItem, deleteAjPurchasePublicItem, getFxxkItineraryDingtalkDetails, updateFxxkItineraryFilesDesStatus } from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            IsDetail: false,
            DetailArr: '',
            key: 'fiId',
            dialog: false,
            edit: false,
            form: {
                appiName: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                // {
                //     field: "",
                //     key: "checkbox",
                //     // type=checkbox
                //     type: "checkbox",
                //     fixed: 'left',
                //     title: "",
                //     width: 50,
                //     align: "center",
                // },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "fiNqName",
                    key: "fiNqName",
                    title: "内勤专用",
                    align: "center",
                    edit: false,
                    fixed: 'left',
                    width: 550,
                },
                {
                    field: "fiNqDateStartStr",
                    key: "fiNqDateStartStr",
                    title: "上课开始日期",
                    align: "center",
                    edit: false,
                    // fixed: 'left',
                    width: 90,
                },
                {
                    field: "fiNqDateEndStr",
                    key: "fiNqDateEndStr",
                    title: "上课结束日期",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "fiNqManage",
                    key: "fiNqManage",
                    title: "项目经理",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "fiNqAssistant",
                    key: "fiNqAssistant",
                    title: "独立助教",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "fiNqInternship",
                    key: "fiNqInternship",
                    title: "实习",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "fiNqWhole",
                    key: "fiNqWhole",
                    title: "项目统筹",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "fiNqProjectType",
                    key: "fiNqProjectType",
                    title: "项目分类",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "fiNqCourseSign",
                    key: "fiNqCourseSign",
                    title: "课程标记",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                { field: "fiNqUserOther", key: "fiNqUserOther", title: "其他人员", width: 160, align: "center" },
                {
                    field: "fiNqUserGo",
                    key: "fiNqUserGo",
                    title: "人员去向",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "fiCreateTimeStr",
                    key: "fiCreateTimeStr",
                    title: "纷享创建时间",
                    align: "center",
                    edit: false,
                    fixed: 'left',
                    width: 160,
                },
                {
                    field: "fiLastModifiedTimeStr",
                    key: "fiLastModifiedTimeStr",
                    title: "纷享最后修改时间",
                    align: "center",
                    edit: false,
                    fixed: 'left',
                    width: 160,
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 100,
                    align: "center",
                    fixed: 'right',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.handleDetail(row)}
                                >
                                    详情
                                </el-button>

                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                fiNqName: '',
                fiNqManage: '',
                fiNqProjectType: '',
                fiNqCourseSign: '',
                fiNqDateStartStrStart:'',
                fiNqDateStartStrEnd:'',
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.getList();
    },
    mounted() { },
    methods: {
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        DownDd(val) {
            this.openLoading()
            updateFxxkItineraryFilesDesStatus({ fiId: val.fiId }).then(res => {
                if (res.data) {
                    this.loadings.close()
                    getFxxkItineraryDingtalkDetails({ fiId: val.fiId }).then(ress => {
                        this.DetailArr = ress.data;
                        this.$message({
                            type: "success",
                            message: "下载成功!",
                        });
                    })
                } else {
                    this.loadings.close()
                }
            }).catch(err => {
                if (err) {
                    this.loadings.close()
                }
            })
        },
        handleDetail(row) {
            getFxxkItineraryDingtalkDetails({ fiId: row.fiId }).then(res => {
                this.DetailArr = res.data;
                this.IsDetail = true;
                console.log(this.DetailArr);
            })
        },
        // 批量删除
        BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        deleteAjPurchasePublicItem({ fiIds: this.selectedRowKeysCollection.toString() }).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });

                                this.partserch()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    deleteAjPurchasePublicItem({ fiIds: row.fiId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        addAjPurchasePublicItem(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAjPurchasePublicItem(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.fiId = row.fiId
                    console.log(jsonObj);
                    updateAjPurchasePublicItem(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getFxxkItineraryDingtalkList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getFxxkItineraryDingtalkList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getFxxkItineraryDingtalkList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>